<div class="md-input-container" fxLayout.xs="column">
    <div>
    <mat-form-field class="mat-form-withtooltip" fxFlex.lt-md="90">
        <mat-label [ngClass]="{'asterix--after': (disabled == true)}">{{WorkerLabelScope}}</mat-label>
        <mat-select [(ngModel)]="value" name="manager" (openedChange)="onOpen($event)"
        [compareWith]="objectComparison" #worker_s="ngModel"
        [required]="required"
        [panelClass]="isLoading || !isOpen ? 'hide-dummy-option' : ''" [disabled] = "disabled"
        >
            <mat-option *ngIf="items === null || !items.length" class="minh88" disabled>
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </div>
            </mat-option>
            <mat-option *ngFor="let item of items" [value]="item">{{item.Name}}</mat-option>
        </mat-select>
        <mat-error class="md-errormsg" *ngIf="!worker_s.valid && worker_s.touched && required">Required</mat-error>
    </mat-form-field>
    <mat-icon fxFlexAlign.lt-md="center" matTooltip='Please select the {{WorkerLabelLC}} or add a new {{WorkerLabelLC}} by clicking "Add New {{WorkerLabel}}" below.' matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
        help
    </mat-icon>
    </div>
    <mat-error class="sm-errormsg" *ngIf="!worker_s.valid && worker_s.touched && required">Required</mat-error>
</div>
